import { useEffect, useState } from 'react';
import type { BrokerIntegration } from './autoResumeLatch';
import { getRelayOwnership, type OwnershipSnapshot } from './relayOwnership';

/**
 * Live view of this tab's ownership of a broker integration (D1, 2026-09-13) — `mode === 'passive'`
 * means another tab holds the socket, so the badge/dialog render the BE state as "connected in
 * another tab" instead of a dead pipe that keeps trying to resume.
 */
export function useRelayOwnership(integration: BrokerIntegration): OwnershipSnapshot {
  const ownership = getRelayOwnership(integration);
  const [snapshot, setSnapshot] = useState<OwnershipSnapshot>(() => ownership.snapshot());
  useEffect(() => {
    setSnapshot(ownership.snapshot());
    return ownership.onEvent((event) => {
      if (event.type === 'change') setSnapshot(event.snapshot);
    });
  }, [ownership]);
  return snapshot;
}
